import { render, staticRenderFns } from "./IframeWrapper.vue?vue&type=template&id=2add9842&"
import script from "./IframeWrapper.vue?vue&type=script&lang=ts&"
export * from "./IframeWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./IframeWrapper.vue?vue&type=style&index=0&id=2add9842&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports